module.exports = __webpack_public_path__ + "img/user.eca5482d.svg";